<template>
  <div>
    <AlertBanner v-if="renderAlert" id="submit-error-alert" :status="0" class="mt-0 sm:mt-32 lg:mt-0">
      <div>Something went wrong while creating your account. Sign up on this page to get started.</div>
    </AlertBanner>
    <corporate-header :logo-image-url="corporateClient.logoImageURL" :corporate-client-name="corporateClient.name" :slug="slug" />
    <generic-error
      v-if="hasError"
      title="We couldn’t find that page"
      class="mt-64"
      button-value="Back to benefits"
      button-href="/bh-benefits"
      >There was an error loading this page. Go back to benefits to try again or
      <a class="link-secondary underline" href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank"
        >contact us</a
      >
      if the issue continues.</generic-error
    >
    <div v-else class="client-specific-signup pt-20 sm:pb-80 sittercity">
      <card class="invisible md:visible block mx-auto mt-36 md:mt-60 sign-up-card w-full" :aria-busy="isLoadingCorporateClient">
        <sign-up-form-skeleton v-if="isLoadingCorporateClient" class="visible" />
        <sign-up-form
          v-else
          :leadid="$route.query.leadid"
          :terms-of-use-link="termsOfUseLink"
          :slug="slug"
          :privacy-policy-link="privacyPolicyLink"
          :corporate-client="corporateClient"
          class="visible"
        />
      </card>
    </div>
    <premium-benefits-section v-if="!hasError && !isLoadingCorporateClient" />
    <years-ahead-promo-section v-if="showYearsAhead" ref="years_ahead" :slug="slug" />
  </div>
</template>

<script lang="ts">
import CorporateHeader from '../components/CorporateHeader.vue';
import GenericError from '@/components/generic_error/GenericError.vue';
import SignUpForm from './SignUpForm.vue';
import SignUpFormSkeleton from './SignUpFormSkeleton.vue';
import YearsAheadPromoSection from './YearsAheadPromoSection.vue';
import PremiumBenefitsSection from '../components/PremiumBenefitsSection.vue';
import Card from '@/components/card/Card.vue';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';

import { CORPORATE_SIGNUP_FORM_QUERY } from '@/graphql/bh_benefits/queries';

export default {
  name: 'BhBenefitsSignUp',
  components: {
    AlertBanner,
    SignUpForm,
    SignUpFormSkeleton,
    CorporateHeader,
    GenericError,
    PremiumBenefitsSection,
    YearsAheadPromoSection,
    Card,
  },
  data() {
    return {
      hasError: false,
      isLoadingCorporateClient: true,
      corporateClient: { hasYearsAhead: false },
    };
  },
  computed: {
    slug(): string {
      return this.$route.params.slug;
    },
    termsOfUseLink(): string {
      return '/terms';
    },
    privacyPolicyLink(): string {
      return '/privacy';
    },
    showYearsAhead(): boolean {
      return this.corporateClient.hasYearsAhead && this.$route.query.site === 'years_ahead';
    },
    renderAlert(): boolean {
      const bhError = new URLSearchParams(document.location.search).get('bh_invalid_signup');
      return bhError === 'true';
    },
  },
  watch: {
    corporateClient() {
      this.$nextTick(() => {
        if (this.$route.query.site === 'years_ahead') {
          if (this.corporateClient.hasYearsAhead) {
            const el = this.$refs.years_ahead as any;
            if (el) {
              el.$el.scrollIntoView({ behavior: 'smooth' });
            }
          }
        }
      });
    },
  },
  apollo: {
    corporateClient: {
      query: CORPORATE_SIGNUP_FORM_QUERY,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({ data }) {
        this.isLoadingCorporateClient = false;
        if (data && data.corporateClient && data.corporateClient.isActive) {
          this.corporateClient = data.corporateClient;
        } else {
          this.hasError = true;
        }
      },
      error() {
        this.isLoadingCorporateClient = false;
        this.hasError = true;
      },
    },
  },
};
</script>
